import {Button, Card, Modal, Toast} from "react-bootstrap";
import React, {useEffect, useState} from 'react';
import {BsCheckCircleFill} from "react-icons/bs";
import moment from "moment/moment";

export default function OrganizationSettingModal(props) {
    const [leakFlowRateInputValue, setLeakFlowRateInputValue] = useState(props.flowrate);
    const [leakDurationInputValue, setLeakDurationInputValue] = useState(props.duration);
    const [leakVolumeInputValue, setLeakVolumeInputValue] = useState(props.volume);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupMsgColor, setPopupMessageColor] = useState(null);
    const SETTINGS_OPERATOR_DESCRIPTION = 'Greater Than or Equal to (>=)';
    const SUCCESS_MSG = 'Changes Saved Successfully ';
    const SUCCESS_COLOR = 'green';
    const ERROR_MSG = 'Error updating values, please try again later';
    const ERROR_COLOR = 'red'

    useEffect(() => {
        setLeakFlowRateInputValue(props.flowrate);
        setLeakDurationInputValue(convertSecondsToHm(props.duration));
        setLeakVolumeInputValue(props.volume);
    }, [props.flowrate, props.duration, props.volume])

    const setDefaultExclusionSettings = async () => {
        const durationString = leakDurationInputValue + ':00';
        const seconds = moment.duration(durationString).asSeconds();
        try {
            await props.monitoringService.updateOrganizationLevelFilterRules(props.organizationId, seconds, leakFlowRateInputValue, leakVolumeInputValue);
            setPopupMessage(SUCCESS_MSG);
            setPopupMessageColor(SUCCESS_COLOR);
            setShowPopup(true);
        } catch (e) {
            setPopupMessage(ERROR_MSG);
            setPopupMessageColor(ERROR_COLOR);
            setShowPopup(true);
        }
    }

    const convertSecondsToHm = (input) => {
        const sec = parseInt(input, 10);
        let hours = Math.floor(sec / 3600);
        let minutes = Math.floor((sec - (hours * 3600)) / 60);
        let seconds = sec - (hours * 3600) - (minutes * 60);
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return hours + ':' + minutes;
    }

    const onInputChange = (e, setInput) => {
        let isDurationInput = false;
        let re = /^[0-9\b]+$/;
        if (setInput === setLeakDurationInputValue) {
            isDurationInput = true;
            re = /^[0-9\b\:]+$/;
        }
        if (isDurationInput && e.target.value.length > 5) {
            return;
        }
        if (e.target.value === '' || re.test(e.target.value)) {
            if (isDurationInput && e.target.value.length === 2 && !(leakDurationInputValue.includes(':'))) {
                setInput(e.target.value + ':');
            } else {
                setInput(e.target.value);
            }

        }
    }

    const checkLeakDurationInputValue = () => {
        let finalInputValue = '';
        if (leakDurationInputValue.length === 0) {
            return;
        } else if (leakDurationInputValue.length === 1 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = '0' + leakDurationInputValue + ':00';
        } else if (leakDurationInputValue.length === 2) {
            finalInputValue = leakDurationInputValue + ':00';
        } else if (leakDurationInputValue.length === 3 && leakDurationInputValue.includes(':') && leakDurationInputValue[2] === ':') {
            finalInputValue = leakDurationInputValue + '00'
        } else if (leakDurationInputValue.length === 3 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = leakDurationInputValue.slice(0, 2) + ':0' + leakDurationInputValue.slice(2)
        } else if (leakDurationInputValue.length === 4 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = leakDurationInputValue.slice(0, 2) + ':' + leakDurationInputValue.slice(2)
        } else if (leakDurationInputValue.length === 4 && leakDurationInputValue.includes(':') && leakDurationInputValue[2] === ':') {
            finalInputValue = leakDurationInputValue.slice(0, 3) + '0' + leakDurationInputValue.slice(3)
        } else {
            finalInputValue = leakDurationInputValue;
        }


        if (/^([0-9]?[0-9]|2[0-3]):[0-9][0-9]$/.test(finalInputValue)) {
            setLeakDurationInputValue(finalInputValue);
        } else {
            setLeakDurationInputValue('00:00');
        }
    }

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)} style={{marginTop: '10%', left: '-20%'}}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table>
                    <tbody>
                    <tr>
                        <td style={{width: '28%'}}>
                            Flow Rate (L/h)
                        </td>
                        <td style={{width: '46%'}}>
                            {SETTINGS_OPERATOR_DESCRIPTION}
                        </td>
                        <td style={{width: '25%'}}>
                            <input value={leakFlowRateInputValue} onChange={(e) => onInputChange(e, setLeakFlowRateInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Duration (hh:mm)
                        </td>
                        <td>
                            {SETTINGS_OPERATOR_DESCRIPTION}
                        </td>
                        <td>
                            <input onBlur={checkLeakDurationInputValue} value={leakDurationInputValue} onChange={(e) => onInputChange(e, setLeakDurationInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Volume (L)
                        </td>
                        <td>
                            {SETTINGS_OPERATOR_DESCRIPTION}
                        </td>
                        <td>
                            <input value={leakVolumeInputValue} onChange={(e) => onInputChange(e, setLeakVolumeInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Toast
                        show={showPopup}
                        autohide={true}
                        delay={1200}
                        onClose={() => setShowPopup(false)}
                        style={{
                            position: 'absolute',
                            right: '27%',
                            bottom: '5%',
                            textAlign: 'center',
                            color: popupMsgColor,
                            backgroundColor: '#f8f9fa00',
                            border: 'none',
                            boxShadow: 'none',
                            zIndex: 100
                        }}>
                        <Toast.Body>
                            <Card.Text>{popupMessage}{popupMsgColor === SUCCESS_COLOR ? <BsCheckCircleFill/> : null}</Card.Text>
                        </Toast.Body>
                    </Toast>
                </div>
                <Button variant="primary" onClick={() => setDefaultExclusionSettings()}>Set</Button>
                <Button variant="secondary" onClick={() => props.setShow(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
